import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
  state: {
    unsavedData: false,
    id: 1234, // dummy id so defualt state is logged in and preserves path
    emailVerified: true // default to verified
  },
  actions,
  getters,
  mutations,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js